
<VTextField
    ref="input"
    :label="label"
    v-currency="options"
    :value="formattedValue"
    @change="onChange"
    @input="onInput"
    :disabled="readonly"
    :dense = "dense"
    :outlined = "outlined"

    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"

    :hide-details="hideDetails"
    :readonly="readonly"
    :rules="rules"
    :error-messages="errorMessages"
/>
